import React, { isValidElement, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import axiosConfig from "../../axiosConfig";

import * as headers from "../../shared/language.json";
import { checkFormik } from "../../shared/checkFormikErrors";
import * as regEx from "../../shared/regularExpressions";
import EndUser from "./EndUser";
import { swalSubmit } from "../../shared/swalSubmit";
import "../Forms/Forms.css";

function EditEndUser(props) {
  const [allMunicipalities, setMunicipalities] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [devices, setDevices] = useState([]);
  const [deviceState, setDeviceState] = useState({ data: [] });
  const [deviceAutoComplete, setdeviceAutoComplete] = useState({});
  const [previousDeviceId, setPreviousDeviceId] = useState(0);
  const [loading, setLoading] = useState(true);
  const [checkFormikErrors, setCheckFormikErrors] = useState(false);
  const [beneficiaryId, setBeneficiaryId] = useState();
  const [addressId, setAddressId] = useState();
  const [temporaryAddressId, setTemporaryAddressId] = useState();
  const [hasTemporaryAddress, setHasTemporaryAddress] = useState();
  const history = useHistory();
  const [selected, setSelected] = useState();
  const [isCovid, setIsCovid] = useState();
  const [biometricsDateId, setBiometricsDateId] = useState(1);
  const [alarmsDateId, setAlarmsDateId] = useState(1);
  const [beneficiaryChartData, setBeneficiaryChartData] = useState([]);
  const [beneficiaryAlarms, setBeneficiaryAlarms] = useState([]);
  const [isMainInfoDisabled, setIsMainInfoDisabled] = useState(false);
  const [isAddressDisabled, setIsAddressDisabled] = useState(false);
  const [isTemporaryAddressDisabled, setIsTemporaryAddressDisabled] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const [IsValidAddress, setIsValidAddress] = useState(false);

  const editMainInfo = () => {
    setIsMainInfoDisabled(!isMainInfoDisabled);
  };
  const editAddress = () => {
    setIsAddressDisabled(!isAddressDisabled);
  };
  const editTemporaryAdress = () => {
    setIsTemporaryAddressDisabled(!isTemporaryAddressDisabled);
  };

  let savedData;
  useEffect(() => {
    let beneficiary;
    const unusedDevices = axiosConfig.get("/Device/GetUnusedDevices");
    if (props.location.selected) {
      setSelected(props.location.selected);
      beneficiary = axiosConfig.get(`/Beneficiary/${props.location.selected}`);
    } else {
      savedData = localStorage.getItem("selected");
      setSelected(savedData);
      beneficiary = axiosConfig.get(`/Beneficiary/${savedData}`);
    }
    const municipalities = axiosConfig.get("/Municipality/All");

    axios
      .all([unusedDevices, beneficiary, municipalities])
      .then(
        axios.spread((...res) => {
          const responseUnusedDevices = res[0];
          setDevices(responseUnusedDevices.data);
          const responseBeneficiary = res[1];
          const responseMunicipalities = res[2];
          setMunicipalities(responseMunicipalities.data);
          setIsCovid(responseBeneficiary.data.isCovid);
          setBeneficiaryId(responseBeneficiary.data.id);
          setAddressId(responseBeneficiary.data.addresses[0].id);
          formik.setValues(responseBeneficiary.data);
          addressFormik.setFieldValue(
            "number",
            responseBeneficiary.data.addresses[0].number
          );
          addressFormik.setFieldValue(
            "postalcode",
            responseBeneficiary.data.addresses[0].postalcode
          );
          addressFormik.setFieldValue(
            "street",
            responseBeneficiary.data.addresses[0].street
          );
          addressFormik.setFieldValue(
            "floor",
            responseBeneficiary.data.addresses[0].floor
          );
          addressFormik.setFieldValue(
            "area",
            responseBeneficiary.data.addresses[0].area
          );
          addressFormik.setFieldValue(
            "town",
            responseBeneficiary.data.addresses[0].town
          );
          addressFormik.setFieldValue(
            "latitude",
            responseBeneficiary.data.addresses[0].latitude
          );
          addressFormik.setFieldValue(
            "municipalityId",
            responseBeneficiary.data.addresses?.[0]?.municipalityId
          );
          addressFormik.setFieldValue(
            "longitude",
            responseBeneficiary.data.addresses[0].longitude
          );

          if (responseBeneficiary.data.addresses.length > 1) {
            setHasTemporaryAddress(true);
            responseBeneficiary.data.addresses[1].isPrimary = false;
            if (responseBeneficiary.data.addresses[1].isPrimary === false) {
              setTemporaryAddressId(responseBeneficiary.data.addresses[1].id);
              temporaryAddressFormik.setFieldValue(
                "street",
                responseBeneficiary.data.addresses[1].street
              );
              temporaryAddressFormik.setFieldValue(
                "postalcode",
                responseBeneficiary.data.addresses[1].postalcode
              );
              temporaryAddressFormik.setFieldValue(
                "floor",
                responseBeneficiary.data.addresses[1].floor
              );
              temporaryAddressFormik.setFieldValue(
                "number",
                responseBeneficiary.data.addresses[1].number
              );
              temporaryAddressFormik.setFieldValue(
                "area",
                responseBeneficiary.data.addresses[1].area
              );
              temporaryAddressFormik.setFieldValue(
                "quarantineDays",
                responseBeneficiary.data.addresses[1].quarantineDays
              );
              temporaryAddressFormik.setFieldValue(
                "town",
                responseBeneficiary.data.addresses[1].town
              );
              temporaryAddressFormik.setFieldValue(
                "latitude",
                responseBeneficiary.data.addresses[1].latitude
              );
              temporaryAddressFormik.setFieldValue(
                "longitude",
                responseBeneficiary.data.addresses[1].longitude
              );
              temporaryAddressFormik.setFieldValue(
                "municipalityId",
                responseBeneficiary.data.addresses?.[1]?.municipalityId
              );
            }
          } else {
            setHasTemporaryAddress(false);
            temporaryAddressFormik.setFieldValue("area", "");
            temporaryAddressFormik.setFieldValue("street", "");
            temporaryAddressFormik.setFieldValue("postalcode", "");
            temporaryAddressFormik.setFieldValue("floor", "");
            temporaryAddressFormik.setFieldValue("number", "");
            temporaryAddressFormik.setFieldValue("town", "");
            temporaryAddressFormik.setFieldValue("quarantineDays", 14);
            temporaryAddressFormik.setFieldValue("municipalityId", "");
            temporaryAddressFormik.setFieldValue("latitude", 0);
            temporaryAddressFormik.setFieldValue("longitude", 0);
          }
          setDeviceState((prevState) => ({
            ...prevState,
            data: responseBeneficiary.data.devices,
          }));

          setLoading(false);
          localStorage.removeItem("selected");
        })
      )
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      middlename: "",
      genderId: "",
      personOfContact: "",
      telephone: "",
      mobile: "",
      email: "",
      yearOfBirth: 0,
      latitude :0,
      longitude:0
    },
    validationSchema: Yup.object({
      firstname: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegex,
          headers.FORMIKERRORMESSAGES.FIRSTLETTERCAPITAL
        )
        .matches(regEx.lettersOnly, headers.FORMIKERRORMESSAGES.LETTERSONLY)
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX),
      lastname: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegex,
          headers.FORMIKERRORMESSAGES.FIRSTLETTERCAPITAL
        )
        .matches(regEx.lettersOnly, headers.FORMIKERRORMESSAGES.LETTERSONLY)
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX),
      middlename: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegex,
          headers.FORMIKERRORMESSAGES.FIRSTLETTERCAPITAL
        )
        .matches(regEx.lettersOnly, headers.FORMIKERRORMESSAGES.LETTERSONLY)
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX),
      genderId: Yup.number().required(headers.FORMIKERRORMESSAGES.REQUIRED),
      personOfContact: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegex,
          headers.FORMIKERRORMESSAGES.FIRSTLETTERCAPITAL
        )
        .matches(regEx.lettersOnly, headers.FORMIKERRORMESSAGES.LETTERSONLY)
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX),
      telephone: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.phoneRegExp, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(10, headers.FORMIKERRORMESSAGES.TENDIGITSONLY)
        .max(10, headers.FORMIKERRORMESSAGES.TENDIGITSONLY),
      mobile: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.phoneRegExp, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(10, headers.FORMIKERRORMESSAGES.TENDIGITSONLY)
        .max(10, headers.FORMIKERRORMESSAGES.TENDIGITSONLY),
      email: Yup.string().required(headers.FORMIKERRORMESSAGES.REQUIRED).email(headers.FORMIKERRORMESSAGES.INVALIDEMAIL),
      yearOfBirth: Yup.number().required(headers.FORMIKERRORMESSAGES.REQUIRED),
    }),
    onSubmit: (values) => {
      values = {
        firstname: values.firstname,
        lastname: values.lastname,
        middlename: values.middlename,
        genderId: values.genderId,
        personOfContact: values.personOfContact,
        telephone: values.telephone,
        mobile: values.mobile,
        email: values.email,
        yearOfBirth: values.yearOfBirth,
        id: beneficiaryId,
      };
      values.genderId === 1
        ? formik.setFieldValue("genderId", 1)
        : formik.setFieldValue("genderId", 2);
      Swal.fire({
        title: "",
        text: `Έχετε επιλέξει να πραγματοποιήσετε αλλαγή στα στοιχεία του Ωφελούμενου με κωδ. ${beneficiaryId} Είστε βέβαιοι ;`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ναι",
        cancelButtonText: "Οχι",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(swalSubmit).then((result) => {
            if (result.value) {
              axiosConfig.put(`/Beneficiary`, values).then((res) => {
                if (res.status === 200) {
                  editMainInfo();
                }
              });
            }
          });
        }
      });
    },
  });

  const temporaryAddressFormik = useFormik({
    initialValues: {
      street: "",
      number: "",
      floor: "",
      postalcode: "",
      quarantineDays: "",
      area: "",
      municipalityId: "",
      longitude: 0,
      latitude: 0
    },
    validationSchema: Yup.object({
      street: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.streetRegex,
          headers.FORMIKERRORMESSAGES.GREEKONLYANDFIRSTLETTERCAPITAL
        )
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(40, headers.FORMIKERRORMESSAGES.FOURTYCHARACTERSMAX),
      number: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.streetNumber, headers.FORMIKERRORMESSAGES.STREETNUMBER),
      floor: Yup.number()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .min(-1, headers.FORMIKERRORMESSAGES.FLOORNUMBER)
        .max(20, headers.FORMIKERRORMESSAGES.FLOORNUMBER),
      postalcode: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.numbersOnly, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(5, headers.FORMIKERRORMESSAGES.POSTALCODE)
        .max(5, headers.FORMIKERRORMESSAGES.POSTALCODE),
      municipalityId: Yup.string().required(
        headers.FORMIKERRORMESSAGES.REQUIRED
      ),
      area: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegexGreekOnly,
          headers.FORMIKERRORMESSAGES.LETTERSONLY
        )
        .max(40, headers.FORMIKERRORMESSAGES.FOURTYCHARACTERSMAX),
    }),
    onSubmit: (values) => {
      values = { ...values, beneficiaryId: beneficiaryId };
      Swal.fire({
        title: "",
        text: `Έχετε επιλέξει να πραγματοποιήσετε αλλαγή στα στοιχεία του Ωφελούμενου με κωδ. ${beneficiaryId} Είστε βέβαιοι ;`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ναι",
        cancelButtonText: "Οχι",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(swalSubmit).then((result) => {
            if (result.value) {
              if (hasTemporaryAddress === false) {
                axiosConfig.post(`/Address/TemporaryAddress`, values);
              } else {
                values = { ...values, id: temporaryAddressId };
                axiosConfig
                  .put("/Address/UpdateTemporaryAddress", values)
                  .then((res) => {
                    if (res.status === 200) {
                      editTemporaryAdress();
                    }
                  });
              }
            }
          });
        }
      });
    },
  });
 

  const addressFormik = useFormik({
    initialValues: {
      street: "",
      number: "",
      postalcode: "",
      floor: "",
      id: addressId,
      town: "",
      area: "",
      municipalityId: 0,
      longitude: 0,
      latitude: 0
    },
    validationSchema: Yup.object({
      street: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.streetRegex,
          headers.FORMIKERRORMESSAGES.GREEKONLYANDFIRSTLETTERCAPITAL
        )
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(40, headers.FORMIKERRORMESSAGES.FOURTYCHARACTERSMAX),
      number: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.streetNumber, headers.FORMIKERRORMESSAGES.STREETNUMBER),
      floor: Yup.number()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .min(-1, headers.FORMIKERRORMESSAGES.FLOORNUMBER)
        .max(20, headers.FORMIKERRORMESSAGES.FLOORNUMBER),
      postalcode: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(regEx.numbersOnly, headers.FORMIKERRORMESSAGES.NUMBERSONLY)
        .min(5, headers.FORMIKERRORMESSAGES.POSTALCODE)
        .max(5, headers.FORMIKERRORMESSAGES.POSTALCODE),
      area: Yup.string()
        .required(headers.FORMIKERRORMESSAGES.REQUIRED)
        .matches(
          regEx.nameRegexGreekOnly,
          headers.FORMIKERRORMESSAGES.GREEKONLYANDFIRSTLETTERCAPITAL
        )
        .matches(regEx.lettersOnly, headers.FORMIKERRORMESSAGES.LETTERSONLY)
        .min(4, headers.FORMIKERRORMESSAGES.ATLEASTFOURCHARACTERS)
        .max(40, headers.FORMIKERRORMESSAGES.FOURTYCHARACTERSMAX),
      municipalityId: Yup.number().required(
        headers.FORMIKERRORMESSAGES.REQUIRED
      ),
    }),
    onSubmit: (values) => {
      values = {
        street: values.street,
        number: values.number,
        postalcode: values.postalcode,
        floor: values.floor,
        area: values.area,
        municipalityId: values.municipalityId,
        id: addressId,
        longitude: values.longitude,
        latitude: values.latitude
      };
      Swal.fire({
        title: "",
        text: `Έχετε επιλέξει να πραγματοποιήσετε αλλαγή στα στοιχεία του Ωφελούμενου με κωδ. ${beneficiaryId} Είστε βέβαιοι ;`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ναι",
        cancelButtonText: "Οχι",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(swalSubmit).then((result) => {
            if (result.value)
              axiosConfig.put(`/Address/UpdateAddress`, values).then((res) => {
                if (res.status === 200) {
                  editAddress();
                  setIsValidAddress(false);
                }
              });
          });
        }
      });
    },
  });
  useEffect(() => {
    checkFormik(formik.errors, checkFormikErrors, setCheckFormikErrors);
  }, [formik.errors, checkFormikErrors]);

  const isDeviceEmpty = () => {
    if (deviceState.data.length === 0) {
      setCheckFormikErrors(false);
      Swal.fire("Παρακαλούμε επιβεβαίωστε την Αντικατάσταση, επιλέγοντας Επιβεβαίωση Συσκευής", "", "warning");
    } else {
      setCheckFormikErrors(true);
      history.push({
        pathname: "/smart-band-values",
        selected: deviceState.data[0].id,
        locationPath: "EditEndUser",
      });
      localStorage.setItem("selected", selected);
    }
  };

  useEffect(() => {
    if (deviceState.data.length !== 0) {
      axiosConfig
        .get(
          `/Signal/ByDeviceId?id=${deviceState.data[0].id}&days=${biometricsDateId}`
        )
        .then((res) => {
          let dataWithNewType = [
            ...res.data,
            {
              id: "'Ολοι οι Τύποι",
              data: [],
            },
          ];
          setBeneficiaryChartData(dataWithNewType);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [biometricsDateId, deviceState.data]);

  useEffect(() => {
    if (deviceState.data.length !== 0) {
      axiosConfig
        .get(
          `/Alarm/GetAlarmsByDeviceId?deviceId=${deviceState.data[0].id}&days=${alarmsDateId}`
        )
        .then((res) => {
          setBeneficiaryAlarms(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [alarmsDateId, deviceState.data]);

  const handleChangeBiometricsDateId = (e) => {
    setBiometricsDateId(e.target.value);
  };

  const handleChangeAlarmsDateId = (e) => {
    setAlarmsDateId(e.target.value);
  };

  const checkAddress = (municipalityId, isTemporary) => {
    const addressProperties = {
      street:
        isTemporary === false
          ? addressFormik.values.street
          : temporaryAddressFormik.values.street,
      number:
        isTemporary === false
          ? addressFormik.values.number
          : temporaryAddressFormik.values.number,
      postalcode:
        isTemporary === false
          ? addressFormik.values.postalcode
          : temporaryAddressFormik.values.postalcode,
      floor:
        isTemporary === false
          ? addressFormik.values.floor
          : temporaryAddressFormik.values.floor,
      area:
        isTemporary === false
          ? addressFormik.values.area
          : temporaryAddressFormik.values.area,
    };

    axiosConfig
      .post(`/Address/IsAddressValid/${municipalityId}`, addressProperties)
      .then((res) => {
        formik.setFieldValue("latitude", res.data.latitude);
        formik.setFieldValue("longitude", res.data.longitude);
        isTemporary? temporaryAddressFormik.setFieldValue("latitude", res.data.latitude):addressFormik.setFieldValue("latitude", res.data.latitude);
        isTemporary? temporaryAddressFormik.setFieldValue("longitude", res.data.longitude):addressFormik.setFieldValue("longitude", res.data.longitude);
        setOpenMap(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <EndUser
      setIsValidAddress={setIsValidAddress}
      IsValidAddress={IsValidAddress}
      setOpenMap={setOpenMap}
      openMap={openMap}
      checkAddress={checkAddress}
      editAddress={editAddress}
      editMainInfo={editMainInfo}
      editTemporaryAdress={editTemporaryAdress}
      isMainInfoDisabled={isMainInfoDisabled}
      isAddressDisabled={isAddressDisabled}
      isTemporaryAddressDisabled={isTemporaryAddressDisabled}
      formik={formik}
      allMunicipalities={allMunicipalities}
      deviceState={deviceState.data}
      devices={deviceState.data}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      setdeviceAutoComplete={setdeviceAutoComplete}
      devicesOptions={devices}
      previousDeviceId={previousDeviceId}
      deviceAutoCompleteId={deviceAutoComplete.id}
      deviceAutoComplete={deviceAutoComplete}
      setDeviceState={setDeviceState}
      isDeviceEmpty={isDeviceEmpty}
      history={history}
      isEditEndUser={true}
      isAddEndUser={false}
      setPreviousDeviceId={setPreviousDeviceId}
      loading={loading}
      addressFormik={addressFormik}
      temporaryAddressFormik={temporaryAddressFormik}
      clearSavedData={() => { }}
      isCovid={isCovid}
      beneficiaryId={beneficiaryId}
      biometricsDateId={biometricsDateId}
      alarmsDateId={alarmsDateId}
      handleChangeBiometricsDateId={handleChangeBiometricsDateId}
      handleChangeAlarmsDateId={handleChangeAlarmsDateId}
      beneficiaryAlarms={beneficiaryAlarms}
      beneficiaryChartData={beneficiaryChartData}
    />
  );
}

export default EditEndUser;
